module.exports = __webpack_public_path__ + "img/sol.0bf2916a.png";